import * as Styled from './CheckList.styled';

const ListItemsDescription = [
  'Pagamento de fretes',
  'Pagamento de boletos',
  'Transferências Pix e TED',
  'Fluxo de aprovação',
  'Gestão de pessoas',
  'perfis e permissões',
];

function CheckList() {
  return (
    <Styled.List>
      {ListItemsDescription.map((item: string) => {
        return (
          <Styled.Item key={item}>
            <Styled.Icon name="verified-check" iconStyle="filled" />
            {item}
          </Styled.Item>
        );
      })}
    </Styled.List>
  );
}

export default CheckList;
